var turnOnXsListeners,
    turnOffXsListeners;
(function($) {
	$(function() {
		var mobMenuBtn = $('#mob-btn-block');
		turnOnXsListeners = function($) {
			var openedMenu = [],//list of opened menus
			    activeMenu = [],//list of active menu items
			    maxMenuLevel = 3,
			    mainMenuToOpen = $(mobMenuBtn.data('mob-menu-goal')),
			    // mainNavBlock = $('#main-nav-block'),
			    mobMenuBtnOnPanel = $('.on-panel-menu-item.mob-tab-btn-block');

			mobMenuBtn.on('click.xs', function() {
				mainMenuToOpen.addClass('opened show-lang');
				mobMenuBtn.addClass('active');
				mobMenuBtnOnPanel.click();
			});

			headerOnScroll();//for anchors
			$window.on('scroll.xs', function() {
				headerOnScroll();
			});
			function headerOnScroll() {
				if ($window.scrollTop() > 70) {
					if (!activeMenu[0]) {
						$mainNavBlock.removeClass('show-lang');
					}
					$mainNavBlock.addClass('scroll-opened');
				} else {
					$mainNavBlock.removeClass('scroll-opened');
				}
			}
			$('.on-panel-menu-item').on('click.xs', function(e) {
				e.preventDefault();
				var currItem = $(this);
				if (currItem.hasClass('active')) {
					closeMenuBlock(currItem, 0);
					$mainNavBlock.removeClass('opened-from-panel');
					if ($mainNavBlock.hasClass('scroll-opened')) {
						setTimeout(function() {$mainNavBlock.removeClass('show-lang')}, transitionDuration);
					}
				} else {
					if (activeMenu[0]) {
						closeMenuBlock(activeMenu[0], 0);
						setTimeout(openMenuBlock, transitionDuration, currItem, 0);
					} else {
						openMenuBlock(currItem, 0);
						$mainNavBlock.addClass('opened-from-panel');
					}
				}
			});
			$('.mob-menu-item').on('click.xs', function(e) {
				e.preventDefault();
				var currItem = $(this),
				    currItemLevel = currItem.data('mob-menu-level');
				if (currItem.hasClass('active')) {
					closeMenuBlock(currItem, currItemLevel);
				} else {
					openMenuBlock(currItem, currItemLevel);
				}
			});
			function openMenuBlock(menuItem, menuLevel) {
				var menuToOpen = $(menuItem.data('mob-menu-goal'));
				if (menuLevel == 0) {
					openedMenu[menuLevel] = menuToOpen.addClass('opened');
					if (!menuItem.is('#open-accounts')) {
						mainMenuToOpen.addClass('show-lang');
						if (menuItem.is(mobMenuBtnOnPanel)) {
							mobMenuBtn.addClass('active');
						}
					}
				} else {
					openedMenu[menuLevel] = menuToOpen.slideDown(transitionDuration);
				}
				activeMenu[menuLevel] = menuItem.addClass('active');
			}
			function closeMenuBlock(menuItem, menuLevel) {
				if (mobMenuBtn.hasClass('active') && menuLevel == 0) {
					mobMenuBtn.removeClass('active');
					mainMenuToOpen.removeClass('opened');
				}
				var menuToClose = $(menuItem.data('mob-menu-goal'));
				menuItem.removeClass('active');
				if (menuLevel == 0) {
					menuToClose.removeClass('opened');
				} else {
					menuToClose.slideUp(transitionDuration);
				}
				openedMenu[menuLevel] = null;
				activeMenu[menuLevel] = null;
				if (menuLevel < maxMenuLevel - 1) {
					closeInnerItems(menuToClose);
				}
			}
			function closeInnerItems(menuToClose) {
				setTimeout(function() {
					menuToClose.find('.active').removeClass('active').each(function() {
						$($(this).data('mob-menu-goal')).hide();
					});
				}, transitionDuration)
			}
		}
		turnOffXsListeners = function($) {
			mobMenuBtn.off('click.xs');
			$window.off('scroll.xs');
			$('.on-panel-menu-item').off('click.xs');
			$('.mob-menu-item').off('click.xs');
		}
	});
})(jQuery)